import React, {useEffect, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaInfoCircle, FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import projectUtils from "../../../../utils/project-utils.js";
import typePlaceService from "../../../../services/web/type-place-service.js";
import Alert from "../../../../components/alert/alert.jsx";

const TypePlaceForm = () => {
    const navigate = navigateHook();

    const {id} = useParams()
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({name: ""})

    const { data, status, refetch: refetchTypePlace} = useQuery({
        queryFn: () =>  typePlaceService.get(id).then((data) => {
            setState(data)
            return data
        }),
        queryKey: ['typePlace', {id}],
        enabled: !!id
    });

    useEffect(() => {
        if (id) {
            if (status === 'success') setIsLoading(false)
            else setIsLoading(true)
        } else {
            setState({name: ""})
        }
    }, [status]);

    const onChange = ({target: {value, id}}) => setState(prev => ({...prev, [id]: value}))

    const save = () => {
        const formData = new FormData();

        const form = {
            name: state.name
        };

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        if (!!id) formData.append('_method', 'PUT');


        const response = !!id ? typePlaceService.edit(id, formData) : typePlaceService.create(formData);
        response
            .then(({data}) => {
                projectUtils.success(!id);

                if (id) {
                    refetchTypePlace();
                    return;
                }

                navigateToEdit(data)
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = message ?? "Não foi possível salvar.";

                if(errMessage === "name.already.used") errMessage = "Este \"Nome\" já está sendo utilizado."

                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })

    }
    const destroy = () => {
        projectUtils.swalMessage(
            "warning",
            "Excluir",
            `Excluir o tipo de local "${state.name ?? ""}"?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    typePlaceService.destroy(id).then(() => {
                        navigateToList()
                        projectUtils.success(true, "Excluído com sucesso");
                    })
                }
            }
        );
    }

    const navigateToList = () => {
        let isBlank = false;
        let urlDev = `/typePlace`;
        navigate(urlDev, isBlank);
    }

    const newTypePlace = () => {
        let isBlank = false;
        let urlDev = `/typePlace/form`;
        navigate(urlDev, isBlank);
    }

    const navigateToEdit = (data) => {
        let isBlank = false;
        let urlDev = `/typePlace/form/${data.id}`;
        navigate(urlDev, isBlank);
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Tipo de local
                </Template.Title>
                {
                    id &&
                    <>
                        <Button target={"primary-outline"} onClick={() => newTypePlace()}>
                            <FaPlus/>
                            Adicionar tipo de local
                        </Button>
                    </>
                }
            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12">
                                <InputForm id="name" value={state.name} onChange={onChange}
                                           label="Nome *"/>
                            </div>
                        </div>

                    </Card.Body>
                </Card>

                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end">
                            <div className="flex gap-2">
                                {
                                    (data && data?.isSystem) &&
                                    <Alert className={"flex gap-2 items-center"} target={"info"}>
                                        <FaInfoCircle /> Esse é um tipo de local padrão de sistema e não pode ser editado ou excluído
                                    </Alert>
                                }

                                {
                                    (!data || !data?.isSystem) &&
                                    <>
                                        {
                                            id &&
                                            <>
                                                <Button target="danger" onClick={destroy} actionFeedbackType='delete'>
                                                    Excluir
                                                </Button>
                                            </>
                                        }

                                        <Button onClick={save} actionFeedbackType='save'>
                                            Salvar
                                        </Button>
                                    </>
                                }
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default TypePlaceForm;